// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-39d9ae03] .el-table__header-wrapper{height:100%!important}[data-v-39d9ae03] .el-dialog__body{overflow:auto!important}", ""]);
// Exports
module.exports = exports;
